// extracted by mini-css-extract-plugin
module.exports = {"container":"Poll_container__QkjqF","unanswered":"Poll_unanswered__bZpnF","cardContent":"Poll_cardContent__mY-Se","pac":"Poll_pac__dcuqn","puac":"Poll_puac__39EBo"};